import {
  ChangePasswordPayload,
  // ChangeUserProfilePayload,
  RegisterPayLoad,
  ResetPasswordPayload,
} from '@/types/user'
import axiosClient, { identityClient } from './axiosClient'

const authApi = {
  forgotPassword(email: string) {
    // move to web identity
    const url = 'api/user/forgetpassword'
    return axiosClient.post(`${url}?email=${email}`)
  },
  resetPassword(payload: ResetPasswordPayload) {
    // move to web identity
    const url = '/api/user/resetpassword'
    return axiosClient.post(url, payload)
  },
  changePassword(payload: ChangePasswordPayload) {
    const url = '/api/auth/change-password'
    return identityClient.post(url, payload)
  },
  register(payload: RegisterPayLoad) {
    // move to web identity
    const url = '/api/user/register'
    return axiosClient.post(url, payload)
  },
  // getProfile() {
  //   const url = 'api/user/profile'
  //   return axiosClient.get(url)
  // },
  // changeProfile(payload: ChangeUserProfilePayload) {
  //   const url = 'api/user/profile'
  //   return axiosClient.put(url, payload)
  // },
}

export default authApi
